module.exports = __webpack_public_path__ + "img/P4-3-4.dde3b549.png";